import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

function ToyListFooter() {
  return (
    <Box sx={{
      bgcolor: 'grey.100',
      py: 4,
      mt: 8,
      borderTop: 1,
      borderColor: 'divider'
    }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              ToyPort
            </Typography>
            <Typography variant="body2" color="text.secondary">
              The ultimate toy and model collection manager. Built by collectors, for collectors.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Features
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              • Complete collection management
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              • Multi-currency support
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              • Preorder tracking
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • Cloud sync
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Support
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Free to use with no hidden costs
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Your collection is private and secure
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{ mt: 4, pt: 3, borderTop: 1, borderColor: 'divider', textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            © 2024 ToyPort. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default ToyListFooter; 